"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payoutTransactionFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
exports.payoutTransactionFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    transaction_id: Factory.each(i => i + 1),
    transaction_date: mocks_1.dates.date2100,
    transaction_type: 'transaction_type',
    transaction_url: 'transaction_url',
    gross_cents: Factory.each(i => i + 1),
    fee_cents: Factory.each(i => i + 1),
    net_cents: Factory.each(i => i + 1),
    sale_id: 'sale_id',
    payout_id: Factory.each(i => i + 1),
    payout_bank_account: 'payout_bank_account',
    payout_deposit_date: mocks_1.dates.date2100,
    payment_processor: 'payment_processor',
    payment_processor_id: 'payment_processor_id',
    payment_method: 'eCheck',
    tenant_id: Factory.each(i => i + 1),
    tenant_type: 'tenant_type',
    source_system: 'source_system',
    source_system_id: Factory.each(i => i + 1),
    account_owner_first_name: 'account_owner_first_name',
    account_owner_last_name: 'account_owner_last_name',
    account_owner_id: Factory.each(i => i + 1),
    participants: ['participant1', 'participant2'],
    department: 'department',
    originator_description: 'originator_description',
    originator_id: 'originator_id',
    user_id: Factory.each(i => i + 1),
    card_holder_name: 'card_holder_name',
});
